import { isPlatform } from '@ionic/react';
import { default as OneSignalMobile } from 'onesignal-cordova-plugin';
import NotificationReceivedEvent from 'onesignal-cordova-plugin/dist/NotificationReceivedEvent';
import { OneSignalConfig, OneSignalSDK } from './OneSignalService';

/** OneSignal Mobile Push Bridge */
export class OneSignalMobileImpl implements OneSignalSDK {
  public logger = console;
  setLogger(logger: Console) {
    this.logger = logger;
  }
  init(config: OneSignalConfig): Promise<void> {
    return new Promise((resolve, reject) => {
      // Uncomment to set OneSignal device logging to VERBOSE
      // OneSignalMobile.setLogLevel(6, 0);
      // NOTE: Update the setAppId value below with your OneSignal AppId.
      OneSignalMobile.setAppId(config.appId);
      resolve();
    });
  }
  isPushNotificationsEnabled(): Promise<boolean> {
    const logger = this.logger;
    return new Promise((resolve, reject) => {
      const win = window as any;
      win.plugins.OneSignal.getDeviceState(function (stateChanges) {
        logger.debug('isPushNotificationsEnabled()', stateChanges);
        resolve(stateChanges.subscribed);
      });
    });
  }
  setSubscription(newSubscription: boolean, externalUserId: string) {
    const logger = this.logger;
    return new Promise<void>((resolve, reject) => {
      const win = window as any;
      logger.log('newSubscription : ' + newSubscription);
      win.plugins.OneSignal.disablePush(!newSubscription);
      if (newSubscription) {
        win.plugins.OneSignal.setExternalUserId(externalUserId, (results) => {
          // Push can be expected in almost every situation with a success status, but
          // as a pre-caution its good to verify it exists
          if (results.push && results.push.success) {
            logger.log(
              'Results of setting external user id push status: ' +
                results.push.success
            );
            resolve();
          } else {
            logger.warn(
              'Results of setting external user id push status: ' +
                results.push.success
            );
            reject();
          }
        });
      } else {
        resolve();
      }
    });
  }
  getNotificationPermission(onComplete?: Function) {
    return new Promise<NotificationPermission>((resolve, reject) => {
      const logger = this.logger;
      const win = window as any;
      win.plugins.OneSignal.getDeviceState(function (stateChanges) {
        logger.log(
          'getNotificationPermission getDeviceState: ' +
            JSON.stringify(stateChanges)
        );

        // 0 = NotDetermined, 1 = Denied, 2 = Authorized, 3 = Provisional, 4 = Ephemeral
        // "default" | "denied" | "granted";
        let perm = '';
        switch (stateChanges.notificationPermissionStatus) {
          case 1:
            perm = 'denied';
            break;
          case 2:
          case 3:
          case 4:
            perm = 'granted';
            break;
          case 0:
          default:
            if (
              isPlatform('android') &&
              stateChanges.hasNotificationPermission
            ) {
              // Android: no native prompt for notification
              perm = 'granted';
            } else {
              perm = 'default';
            }
            break;
        }
        onComplete && onComplete(perm);
        logger.log('perm : ' + perm);
        resolve(perm as NotificationPermission);
      });
    });
  }
  showPrompt() {
    return new Promise<void>((resolve, reject) => {
      // No prompt required for Android
      // IOS prompt
      // if (isPlatform("ios")) {
      //Prompts the iOS user for push notifications ?
      OneSignalMobile.promptForPushNotificationsWithUserResponse(function (
        accepted
      ) {
        console.log('User accepted notifications: ' + accepted);
        accepted ? resolve() : reject();
      });
      // }
    });
  }
  setNotificationOpenedHandler(handler) {
    OneSignalMobile.setNotificationOpenedHandler(handler);
  }
  setNotificationWillShowInForegroundHandler(
    handler: (event: NotificationReceivedEvent) => void
  ) {
    OneSignalMobile.setNotificationWillShowInForegroundHandler(handler);
  }
}
